import { render, staticRenderFns } from "./TestQuestionReport.vue?vue&type=template&id=1388ac34&scoped=true"
import script from "./TestQuestionReport.vue?vue&type=script&lang=js"
export * from "./TestQuestionReport.vue?vue&type=script&lang=js"
import style0 from "./TestQuestionReport.vue?vue&type=style&index=0&id=1388ac34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388ac34",
  null
  
)

export default component.exports